import { Injectable } from '@angular/core';
import { FastTransactionResponse } from './fast-transaction';

@Injectable({
  providedIn: 'root'
})
export class FastTransactionMapper {

  public toFastTransactionResponse(apiResponse: any): FastTransactionResponse {
    return {
      transactionList: apiResponse.fastTransactionList,
      pagingData: {
        nextPageTransDate: apiResponse.nextPageTransDate?.split('T')[0],
        nextPageTransId: apiResponse.nextPageTransId,
        prevPageTransDate: apiResponse.prevPageTransDate?.split('T')[0],
        prevPageTransId: apiResponse.prevPageTransId,
        pageSize: apiResponse.pageSize,
        firstPage: apiResponse.firstPage,
        lastPage: apiResponse.lastPage
      }
    }
  }
}